import { useLocation, Outlet, useNavigate } from "react-router-dom";
//hooks
import useAuth from "./../../hooks/useAuth";
// components
import MainNavbar from "./MainNavbar";
import MainFooter from "./MainFooter";
import { PlaceOrderProvider } from "./../../contexts/PlaceOrderContext";
import { SubNavbar } from "./SubNavbar";
import useCategories from "../../hooks/useCategories";
import { useState } from "react";
import { useDispatch, useSelector } from "./../../redux/store";
import { keywordSearch } from "../../redux/slices/globalSearch";
import { debounce } from "../../utils/FuncUtils";
// import MainTopNavbar from "./MainTopNavbar";

// ----------------------------------------------------------------------

export default function MainLayout() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useAuth();
  const { headerCategories } = useCategories();
  const { isGlobalSearchLoading, searchedItems } = useSelector(
    (state) => state.globalSearch
  );
  const [searchCategory, setSearchCategory] = useState("All");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isSearchDropdownVisible, setIsSearchDropdownVisible] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  //Function to handel search category change
  const handelSearchCategoryChange = (e) => {
    const { value } = e.target;
    setSearchCategory(value);
    if (searchKeyword) {
      debounceHandleChange(value, searchKeyword);
    }
  };

  //Function to handel global search
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setSearchKeyword(value);
    if (value) {
      showSearchDropdown();
      debounceHandleChange(searchCategory, value);
    } else {
      hideSearchDropdown();
    }
  };

  //Function to handel responsive global search
  const handelSearchResponsive = (e) => {
    const { name, value } = e.target;
    setSearchKeyword(value);
    debounceHandleChange(searchCategory, value);
  };

  //Function to handel global search using debounce
  const debounceHandleChange = debounce((category, keyword) => {
    let globalSearchPayload = {
      category: category !== "" ? category : searchCategory,
      keyword: keyword !== "" ? keyword : searchKeyword,
    };
    dispatch(keywordSearch(globalSearchPayload));
  }, 400);

  //Function to show search dropdown
  const showSearchDropdown = () => {
    if (isSearchDropdownVisible === false) {
      setIsSearchDropdownVisible(true);
    }
  };

  //Function to show search dropdown
  const hideSearchDropdown = () => {
    setIsSearchDropdownVisible(false);
  };

  //Function to handel dropdown option selection
  const handelSearchedItemSelection = (selectedItem) => {
    setSearchKeyword(selectedItem);
    hideSearchDropdown();
    navigate(`/mobiles?keyword=${selectedItem}`);
  };

  //Function to handel dropdown option selection
  const handelSearchedItemSelectionResponsive = (selectedItem) => {
    setSearchKeyword(selectedItem);
    navigate(`/mobiles?keyword=${selectedItem}`);
    window.location.reload();
  };

  //Function to handel search
  const search = () => {
    if (searchKeyword !== null) {
      navigate(`/mobiles?keyword=${searchKeyword}`);
      window.location.reload();
    }
  };

  return (
    <>
      {/* <MainTopNavbar /> */}
      <MainNavbar
        renderSearchBar={true}
        handelSearchCategoryChange={handelSearchCategoryChange}
        setSearchKeyword={setSearchKeyword}
        handleSearch={handleSearch}
        searchKeyword={searchKeyword}
        search={search}
        searchedItems={searchedItems}
        isGlobalSearchLoading={isGlobalSearchLoading}
        handelSearchedItemSelection={handelSearchedItemSelection}
        isSearchDropdownVisible={isSearchDropdownVisible}
        hideSearchDropdown={hideSearchDropdown}
      />
      <SubNavbar
        categories={headerCategories}
        setSearchKeyword={setSearchKeyword}
        handleSearch={handelSearchResponsive}
        searchKeyword={searchKeyword}
        search={search}
        searchedItems={searchedItems}
        isGlobalSearchLoading={isGlobalSearchLoading}
        handelSearchedItemSelection={handelSearchedItemSelectionResponsive}
      />
      <div>
        {isAuthenticated ? (
          <>
            <Outlet />
          </>
        ) : (
          <Outlet />
        )}
      </div>

      {!isHome ? <MainFooter /> : <MainFooter />}
    </>
  );
}
